import React from 'react';
import { withTranslation } from 'react-i18next';
import Backend from '../../../../Layouts/Backend';
import { Alert, Button } from '../../../../UI/Common';
import Datagrid from '../../../../UI/Datagrid';
import { cloneDeep } from 'lodash';
import PasswordConfirmation from '../../../../UI/PasswordConfirmation';
import helper from '../../../../../utils/helper';

function ConfigSensorsPage({ t, mobileConfig, ...props }) {
  const columns = [
    { dataField: 'groupName', text: 'Group', sort: true },
    { dataField: 'sensorName', text: 'Sensor Name', sort: true },
    {
      dataField: 'pinnedPosition',
      text: 'Position',
      sort: true,
      editable: true,
    },
  ];
  const defaultSorted = [
    {
      dataField: 'groupName',
      order: 'asc',
    },
  ];
  const [sensorIds, setSensorIds] = React.useState([]);
  const [sensors, setSensors] = React.useState([]);
  React.useEffect(() => {
    const result = [];
    props.sensors.map((sensor) => {
      if (sensor.checked) {
        result.push(sensor.sensorId);
      }
    });
    setSensorIds(result);
    setSensors(props.sensors);
  }, [props.sensors]);
  const selectRow = {
    mode: 'checkbox',
    clickToSelect: true,
    clickToEdit: true,
    selected: sensorIds,
    onSelect: onSelect,
    onSelectAll: onSelectAll,
  };
  function onSelect(row, isSelect) {
    if (isSelect) {
      setSensorIds([...sensorIds, row.sensorId]);
    } else {
      setSensorIds(sensorIds.filter((x) => x !== row.sensorId));
    }
  }

  function onSelectAll(isSelect, rows) {
    const ids = rows.map((r) => r.sensorId);
    if (isSelect) {
      setSensorIds((sensorIds) => helper.tableHelper.selectAll(sensorIds, ids));
    } else {
      setSensorIds((sensorIds) =>
        helper.tableHelper.deselectAll(sensorIds, ids),
      );
    }
  }
  function onEditCell(oldValue, newValue, row, column) {
    setSensors(cloneDeep(props.sensors));
  }
  const [openModal, setOpenModal] = React.useState(false);
  const isRequireConfirmation = helper.isRequireConfirmation();
  function onSubmit() {
    if (isRequireConfirmation) {
      setOpenModal(true);
    } else {
      onProceed();
    }
  }
  function onProceed() {
    const _sensors = cloneDeep(sensors);
    _sensors.forEach((sensor) => {
      if (sensorIds.includes(sensor.sensorId)) {
        sensor.checked = true;
      } else {
        sensor.checked = false;
      }
    });
    props.onConfig(_sensors);
  }
  return (
    <Backend
      title={`Configure Sensors: ${
        mobileConfig ? mobileConfig.name || '' : ''
      }`}
    >
      <div className="content-inner">
        <Alert.Error text={props.errors} />
        <PasswordConfirmation
          isOpen={openModal}
          onCancel={() => setOpenModal(false)}
          onConfirm={() => {
            setOpenModal(false);
            onProceed();
          }}
        />
        <Datagrid
          noExport
          datagridProps={{
            keyField: 'sensorId',
            data: props.sensors,
            columns,
            loading: props.loading,
            defaultSorted,
            selectRow,
          }}
          onEditCell={onEditCell}
        />
        <Button
          id="config-sensors-btn"
          classes="mt-20"
          loading={props.isSubmitting}
          onClick={onSubmit}
        >
          <i className="md-icon">done</i>
          {t('Configure')}
        </Button>
      </div>
    </Backend>
  );
}

export default withTranslation('app')(ConfigSensorsPage);
